module.exports = __webpack_public_path__ + "static/img/pingtaibg4.0ce6e0f1.png";